const state = {
  phoneAccount: [],
  currentPage: null,
  lastPage: null,
  nextPage: null,
  prevPage: null,
  total: null,
  from: null,
  to: null
}

const getters = {
  phoneAccount (state) {
    return state.phoneAccount
  },
  currentPage (state) {
    return state.currentPage
  },
  lastPage (state) {
    return state.lastPage
  },
  nextPage (state) {
    return state.nextPage
  },
  prevPage (state) {
    return state.prevPage
  },
  total (state) {
    return state.total
  },
  from (state) {
    return state.from
  },
  to (state) {
    return state.to
  }
}

const mutations = {
  SET_PHONE_ACCOUNT (state, phoneAccount) {
    state.phoneAccount = phoneAccount
  },
  SET_CURRENT_PAGE (state, currentPage) {
    state.currentPage = currentPage
  },
  SET_LAST_PAGE (state, lastPage) {
    state.lastPage = lastPage
  },
  SET_NEXT_PAGE (state, nextPage) {
    state.nextPage = nextPage
  },
  SET_PREV_PAGE (state, prevPage) {
    state.prevPage = prevPage
  },
  SET_TOTAL (state, total) {
    state.total = total
  },
  SET_FROM (state, from) {
    state.from = from
  },
  SET_TO (state, to) {
    state.to = to
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
